const ADMIN_DASHBOARD_API_ROOT = '/admin/dashboard';

export const ADMIN_DASHBOARD_API_PATHS = {
  GET_SALES_COMPARISON: `${ADMIN_DASHBOARD_API_ROOT}/sales-comparison`,
};
